<template>
  <div>
    <div v-for="(page, index) in pageGroupedElements" :key="'page-' + index" class="position-relative dinA4">
      <img :src="require('@/assets/international-header.png')" class="mb-0 page__header" />
      <div v-if="pageGroupedElements[index][0].type !== 'huge'" class="page__container">
        <div v-for="(element, elementIndex) in page" :key="'element-' + elementIndex">
          <div v-if="element.type === 'table'">
            <div class="d-flex justify-center">
              <PdfProductTable :type="element.tableType" :tableData="productTableList[element.id]" :tableId="element.id"
                :image="element.imageUrl" />
            </div>
          </div>
          <div v-else class="d-flex">
            <div>
              <p class="body-2 body-2--bold mb-0 mt-4 ml-0 pl-0">
                {{ element.intro }}
              </p>
              <p v-if="element.intro2" class="body-2 body-2--bold mb-0 mt-0 ml-0 pl-0">
                {{ element.intro2 }}
              </p>
              <ul v-if="element.list" class="list-style-none body-2 justify-text">
                <li v-for="(listElement, indexList) in element.list" :key="'elementList' + indexList" class="pl-4">
                  {{ listElement }}
                </li>
              </ul>
              <p v-if="element.next" class="body-2 body-2--bold mb-0 mt-4">
                {{ element.title ? element.title : 'Otras consideraciones:' }}
              </p>
              <ul v-if="element.next" class="list-style-none body-2 justify-text">
                <li class="pl-4">
                  - Envíos que superan las dimensiones (SPECIAL HANDLING Exceed Dimensions): Se
                  aplicará un suplemento de 65,45<span class="euro-symbol">€</span>
                  en los envíos en los que uno o más bultos pese 30 kg o más y cualquiera de las
                  medidas supera las siguientes dimensiones: 1.2 m (L) x 1.2 m (W) x 1.5 m (H).
                </li>
                <li class="pl-4" v-if="elementIndex === 1">
                  - Envíos no transportables (SPECIAL HANDLING Non Conveyable): Se aplicará un
                  suplemento de 53,55<span class="euro-symbol">€</span>
                  en los envíos en los que uno o más bultos pese menos de 30 kg, y cualquiera de las
                  medidas supera las dimensiones 1.2m (L) x 0.7m (W) x 0.6m (H).
                </li>
                <li class="pl-4" v-else>
                  - Envíos no transportables (SPECIAL HANDLING Non Conveyable): Se aplicará un
                  suplemento de 53,55<span class="euro-symbol">€</span>
                  en los envíos en los que uno o más bultos pese menos de 30 kg, y cualquiera de las
                  medidas supera las dimensiones 2.4m (L) x 1.2m (W) x 1.8m (H).
                </li>

                <li class="pl-4">
                  - Envíos no apilables (SPECIAL HANDLING Non Stackable): Se aplica un suplemento de
                  178,50<span class="euro-symbol">€</span>
                  a cualquier envío que contenga al menos una pieza que no sea apilable. No apilable
                  significa que una pieza o pallet no puede apilarse verticalmente de una manera
                  segura (Nota: el recargo facturado no representa un servicio reservado y no
                  contiene ninguna garantía de CTT Express en la medida en que los respectivos
                  envíos posiblemente no puedan apilarse en un punto durante el transporte.)
                </li>
                <li class="pl-4">
                  - Recogidas.
                  <ul class="list-style-none body-2">
                    <li class="pl-8">
                      * Se aplicará un suplemento de
                      {{ getAdditionalServiceById('REC_DENTRO_UE').value
                      }}<span class="euro-symbol">€</span> por recogidas solicitadas dentro de la
                      UE.
                    </li>
                    <li class="pl-8">
                      * Se aplicará un suplemento de
                      {{ getAdditionalServiceById('REC_FUERA_UE').value
                      }}<span class="euro-symbol">€</span> por recogidas solicitadas fuera de la UE.
                    </li>
                  </ul>
                </li>
                <li class="pl-4 pt-4">
                  <b>Nota Importante:</b> Los envíos con valor comercial a Países fuera de la Unión
                  Europea deben ir acompañados factura comercial original y 4 copias firmadas y
                  selladas por el exportador redactadas en inglés o en el idioma oficial del País de
                  destino.
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        <img :src="require('@/assets/huge-table.png')" class="pl-0 pr-0 page__header" />
        <div class="page__container text-center">
          <ul class="list-style-none body-2">
            <li>
              Consultar = Consultar estos destinos con el Consultor Comercial de su Zona.
            </li>
            <li>
              CTT Express se reserva el derecho de anular y/o modificar en cualquier momento las
              zonas de servicio ofertadas.
            </li>
            <li>
              Los tiempos de transito son orientativos y pueden variar en función de la ciudad o
              Origen y Destino de los mismos.
            </li>
          </ul>
        </div>
      </div>

      <Footer logo :page="previousPages + 1 + index" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { GET_PDF_PRODUCT_TABLE_LIST } from '@/store/modules/offer/getters'
import PdfProductTable from '@/containers/offer-form/sign-off/pdf-venta-directa-2022/PdfProductTable'
import Footer from '@/containers/offer-form/sign-off/pdf-venta-directa-2022/Footer'

export default {
  name: 'InternationalTables',
  components: {
    PdfProductTable,
    Footer,
  },
  data() {
    return {
      elements: [
        {
          type: 'table',
          imageUrl: require('@/assets/express-icon.png'),
          index: 13,
          id: 'INTEXP',
          tableType: 'international',
        },
        {
          type: 'text',
          relatedTable: 13,
          title: 'Otras consideraciones del servicio CTT Internacional Express:',
          intro: 'Características principales del servicio CTT Internacional Express:',
          list: [
            '- Peso máximo por bulto: 40 kg',
            '- Medidas máximas por bulto: Suma de alto, ancho y largo no superior a 240 cm, con ninguna medida superior a 120 cm. Otros pesos y medidas consultar.',
            '- Cubicaje: Conversión volumétrica 200 kg/m3.',
            '- Nº de bultos: Multibulto.',
          ],
          next: true,
        },
        {
          type: 'table',
          imageUrl: require('@/assets/economy-icon.png'),
          index: 14,
          id: 'INTSTD',
          tableType: 'economy',
        },
        {
          type: 'text',
          relatedTable: 14,
          intro: 'Características principales del servicio CTT Internacional Economy:',
          list: [
            '- Peso máximo por bulto: 40 kg',
            '- Medidas máximas por bulto: Suma de alto, ancho y largo no superior a 240 cm, con ninguna medida superior a 120 cm. Otros pesos y medidas consultar.',
            '- Cubicaje: Conversión volumétrica 250 kg/m3.',
            '- Nº de bultos: Multibulto.',
          ],
          next: true,
        },
        { type: 'huge' },
        {
          type: 'table',
          imageUrl: require('@/assets/ecommerce-icon.png'),
          index: 15,
          id: 'ECOMM',
          tableType: 'ecommerce',
        },
        {
          type: 'text',
          relatedTable: 15,
          intro: 'Características de los servicios E-commerce:',
          list: [
            '- Peso máximo por bulto: 30kg.',
            '- Medidas máximas por bulto: 40cm x 30cm x 30cm.',
            '- Cubicaje: Conversión volumétrica 250 kg/m3.',
            '- Nº de bultos: Monobulto.',
            '- Plazo de Entrega: El plazo de entrega para estos destinos es de 5 a 7 días.',
            '(*) Incluido Trámite exportación a Reino Unido.',
          ],
        },
      ],
      previousPages: 0,
    }
  },
  computed: {
    ...mapGetters('offer', [GET_PDF_PRODUCT_TABLE_LIST]),
    productTableList() {
      return this[GET_PDF_PRODUCT_TABLE_LIST]
    },
    pageGroupedElements() {
      let pages = []
      let pageGroup = []
      let singleRow = false
      let rowElementCounter = 0
      for (let i = 0; i < this.elements.length; i++) {
        let actualElement = this.elements[i]
        if (actualElement.type === 'huge') {
          singleRow = true
        } else if (actualElement.type === 'table') {
          const numberOfRows = Object.keys(this.productTableList[actualElement.id].kgRows).length

          if (numberOfRows > 18) {
            singleRow = true
          }
        }
        if (singleRow) {
          if (rowElementCounter !== 0) {
            pages.push(pageGroup)
            pageGroup = []
            rowElementCounter = 0
          }
          pageGroup.push(actualElement)
          pages.push(pageGroup)
          pageGroup = []
          singleRow = false
        } else {
          pageGroup.push(actualElement)
          rowElementCounter++
          if (rowElementCounter === 2 || rowElementCounter === this.elements.length) {
            pages.push(pageGroup)
            pageGroup = []
            rowElementCounter = 0
          }
        }
      }
      return pages
    },
  },
  methods: {
    getAdditionalServiceById(id) {
      return this.$parent.getAdditionalServiceById(id)
    },
    getAdditionalServiceByDesc(desc) {
      return this.$parent.getAdditionalServiceByDesc(desc)
    },
  },
  created() {
    this.$emit('updateTotalPages', { InternationalTables: this.pageGroupedElements.length })
  },
  mounted() {
    this.previousPages = this.$parent.sectionPreviousPages('InternationalTables')
  },
}
</script>
